import { ActionType } from "typesafe-actions";

import * as actions from "./actions";

export type ReportsAction = ActionType<typeof actions>;

export enum ReportState {
  Pending = "PENDING",
  Ready = "READY",
  Failed = "FAILED",
}

export enum ReportType {
  CONVERSIONS = "CONVERSIONS",
  HOSTS = "HOSTS",
  CLICKS = "CLICKS",
  AIRLINES = "AIRLINES",
  AIRLINES_PRODUCTIVITY = "AIRLINES_PRODUCTIVITY",
  BOOKINGS = "BOOKINGS",
  DIRECTIONS = "DIRECTIONS",
  DYNAMIC_AUCTION = "DYNAMIC_AUCTION",
  API_ERRORS = "API_ERRORS",
}

export enum ReportGeneratorStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  DONE = "DONE",
  FAILED = "FAILED",
  CANCELED = "CANCELED",
}

export interface ReportGeneratorState {
  id: string;
  status: ReportGeneratorStatus;
  progress: number;
}

export interface ReportGenerator extends ReportGeneratorState {
  fileName: string;
  reportType: ReportType;
}

export interface Report {
  id: number;
  reportType: ReportType;
  createdAt: string;
  progress: number;
  url: string;
}

export enum ReportsActionTypes {
  FETCH_REQUEST = "@Reports/FETCH_REQUEST",
  FETCH_SUCCESS = "@Reports/FETCH_SUCCESS",
  FETCH_ERROR = "@Reports/FETCH_ERROR",

  REPORT_GENERATOR_START_SUCCESS = "@Report/REPORT_GENERATOR_START_SUCCESS",
  REPORT_GENERATOR_START_ERROR = "@Report/REPORT_GENERATOR_START_ERROR",
  REPORT_GENERATOR_IS_COMPLETED = "@Report/REPORT_GENERATOR_IS_COMPLETED",

  GENERATOR_STATUS_FETCH_REQUEST = "@Report/GENERATOR_STATUS_FETCH_REQUEST",
  GENERATOR_STATUS_FETCH_SUCCESS = "@Report/GENERATOR_STATUS_FETCH_SUCCESS",
  GENERATOR_STATUS_FETCH_ERROR = "@Report/GENERATOR_STATUS_FETCH_ERROR",

  GENERATOR_CANCEL_FETCH_REQUEST = "@Report/GENERATOR_CANCEL_FETCH_REQUEST",
}

export interface ReportsState {
  readonly count: number;
  readonly reports: Report[];
  readonly isLoading: boolean;

  readonly generators: Record<string, ReportGenerator>;
}

export interface ReportsPayload {
  state?: string;
  reportType?: string;
}
